import { FiUser, FiActivity, FiCalendar } from "react-icons/fi";
import { Student } from "../../../types";

interface StudentsStatsCardsProps {
  students: Student[];
  isValidityExpired: (validity: string) => boolean;
}

function StudentsStatsCards({
  students,
  isValidityExpired,
}: StudentsStatsCardsProps) {
  const activePlans = students.filter(
    (s) => !isValidityExpired(s.validity),
  ).length;

  const expiringIn7Days = students.filter((s) => {
    if (!s.validity) return false;
    const diff = Math.ceil(
      (new Date(s.validity).getTime() - new Date().getTime()) /
        (1000 * 60 * 60 * 24),
    );
    return diff > 0 && diff <= 7;
  }).length;

  const expiredPlans = students.filter((s) =>
    isValidityExpired(s.validity),
  ).length;

  const statsConfig = [
    {
      label: "Total de Alunos",
      value: students.length,
      icon: <FiUser className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      shadowColor: "rgba(102, 126, 234, 0.5)",
    },
    {
      label: "Planos Ativos",
      value: activePlans,
      icon: <FiActivity className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      shadowColor: "rgba(67, 233, 123, 0.5)",
    },
    {
      label: "Vencendo em 7 dias",
      value: expiringIn7Days,
      icon: <FiCalendar className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      shadowColor: "rgba(250, 112, 154, 0.5)",
    },
    {
      label: "Planos Expirados",
      value: expiredPlans,
      icon: <FiCalendar className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      shadowColor: "rgba(240, 147, 251, 0.5)",
    },
  ];

  return (
    <div className="mb-3 grid grid-cols-2 gap-2 sm:mb-6 sm:gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {statsConfig.map((stat, index) => (
        <div
          key={index}
          className="group rounded-xl border border-gray-200 bg-white p-3 shadow-sm transition-all duration-200 active:scale-[0.98] dark:border-gray-700 dark:bg-gray-800/50 sm:rounded-2xl sm:p-5 sm:active:scale-100 md:hover:shadow-lg"
        >
          <div className="flex items-center gap-2.5 sm:flex-row sm:gap-3">
            <div
              className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl transition-transform duration-200 sm:h-12 sm:w-12 sm:rounded-xl sm:group-hover:scale-105"
              style={{
                background: stat.gradient,
                boxShadow: `0 4px 14px -2px ${stat.shadowColor}`,
              }}
            >
              <span className="[&_svg]:h-5 [&_svg]:w-5 sm:[&_svg]:h-6 sm:[&_svg]:w-6">
                {stat.icon}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 sm:text-xs md:text-sm">
                {stat.label}
              </p>
              <p
                className="bg-clip-text text-xl font-bold tabular-nums text-transparent sm:text-2xl md:text-3xl"
                style={{ backgroundImage: stat.gradient }}
              >
                {stat.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StudentsStatsCards;
